import { createStore } from 'satcheljs';
var defaultInboxRuleStore = {
    createdRule: null,
    isInboxRuleDialogShown: false,
    selectedFolderId: null,
    inboxRuleRequestStatus: 0 /* NotInitiated */,
    runRuleNowChecked: false,
};
export default createStore('InboxRuleStore', defaultInboxRuleStore)();
//# sourceMappingURL=store.js.map